type AIPromptSuggestionProps = {
  icon: React.ReactNode;
  onClick?: () => void;
};

export function AIPromptSuggestion({
  icon,
  onClick,
  children,
}: React.PropsWithChildren<AIPromptSuggestionProps>) {
  return (
    <div
      className="border justify-start rounded-lg flex flex-col gap-2 p-4 bg-secondary text-sm font-medium w-[180px] cursor-pointer hover:bg-secondary/80 transition-colors"
      onClick={onClick}
    >
      {icon}
      <span className="text-sm flex-1">{children}</span>
    </div>
  );
}
